export const playGroundKey = {
  userStyleArea: "userStyleArea",
  sampleStyleArea: "sampleStyleArea",
};

export default playGroundKey;
